/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ID } from '@/data/types/Basic';
import { RequestParams } from 'integration/generated/transactions/http-client';

export const STORE_LOCATOR_LIBRARY: any = ['places'];
export const STORE_LIST_RADIUS = "500";
export const NEAREST_STORE_LIST_RADIUS = "50";
export const GOOGLE_MAP_REGION = 'nl';

export const STORE_LIST_RADIUS_LEAFPAGE = "50";
export const MAX_ITEMS_LEAFPAGE = "15";
export const SORTBY_LEAFPAGE = 'city';

export const GOOGLE_MAP_ZOOM = {
	INIT: 7,
	ZOOM: 18,
};

export const DEFAULT_LOCATION = {
	lat: 52.28845,
	lng: 5.96905,
};

export const STORE_LOCATOR_STATE_KEY = 'storeLocator';

export const PROFILE_NAME = 'IBM_Store_Details';
export const MAX_ITEMS = "500";
export const NEAREST_STORE_MAX_ITEMS = "25";
export const RADIUS_UOM = 'KTM';
export const SORTBY = 'city';
export const FILTER_ATTRIBUTES = 'citygroup,seotokencity,seotokenstreet';

export type ByPhysicalStoreIdParams = {
	storeId: string;
	physicalStoreId: string;
	query: {
		[key: string]: string | boolean | ID[] | number;
	};
	params?: RequestParams;
};

export const INIT_CLICKED_STORE_INDEX = -1;

export const PRODUCT_INFO_TABLE_PREFIX = 'product-info-table';
export const ORDER_SKU_LIST_TABLE_PREFIX = 'order-sku-list-table';


export const STLOC_ALL_STORES_DEF_QUERY = {
	radius: STORE_LIST_RADIUS,
	radiusUOM: RADIUS_UOM,
	maxItems: MAX_ITEMS,
	profileName: 'IBM_Store_Details',
	sortBy: SORTBY,
	filterAttributes: 'citygroup,seotokencity,seotokenstreet',
	siteLevelStoreSearch: 'false',
}